
import React, {useState} from 'react';
import menu from '../../resources/icons/menu.png';
import cross from '../../resources/icons/cross.png';
import "../../css/layout/sidebar.css";
import PopulationRow from './rows/SidebarPopulationRow';
import SidebarGDPRow from './rows/SidebarGDPRow';
import SidebarWorldRow from './rows/SidebarWorldRow';
import SidebarDebtRow from './rows/SidebarDebtRow';
import SidebarToolsRow from './rows/SidebarToolsRow';

const SideBar =  ({menuToggle}) => {
    


        let width = "32px";
        if(!menuToggle){
            width = "200px";
        } else{
        }

        

        return(

                <div className="sidebar-menu-div" style={{width: width}}> 
                    
                    <div className="sidebar-menu-items">
                        <ul>
                            <li>
                                <PopulationRow/>
                            </li>
                            <li>
                                < SidebarWorldRow/>
                            </li>
                            <li>
                                <SidebarGDPRow/>
                            </li>
                            <li>
                                < SidebarDebtRow parentExpanded={!menuToggle}/>
                            </li>
                            <li>
                                <SidebarToolsRow/>
                            </li>
                        </ul>
                       
                    </div>
                </div>

        );
        
}


export default SideBar;